import * as React from 'react'

import globalPortalClient from './client'
import Portal, {PortalDefinition} from './Portal'
import {PortalWrangler} from './PortalWrangler'

export const ROOT_POOL_ID = '__root'

export interface PortalPoolRoot extends HTMLElement {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  __portal_pool_id: string
}

const PortalPool: React.FC<{poolId: string; client?: PortalWrangler}> = ({
  poolId,
  client,
}) => {
  const portalClient = React.useMemo(() => client ?? globalPortalClient, [
    client,
  ])
  const [portals, setPortals] = React.useState<PortalDefinition[]>(
    portalClient.getPortals(poolId)
  )
  React.useEffect(() => {
    const unsubscribe = portalClient.subscribe(poolId, () => {
      setPortals(portalClient.getPortals(poolId))
    })
    return () => unsubscribe()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      {portals.map((portal) => (
        <Portal {...portal} key={portal.key} />
      ))}
    </>
  )
}

export default PortalPool

export function getPortalPoolId(el: HTMLElement | PortalPoolRoot): string {
  if (isPortalPoolRoot(el)) {
    return el.__portal_pool_id
  }
  if (el.parentElement) {
    return getPortalPoolId(el.parentElement)
  }
  return ROOT_POOL_ID
}

function isPortalPoolRoot(
  el: HTMLElement | PortalPoolRoot
): el is PortalPoolRoot {
  return Object.prototype.hasOwnProperty.call(el, '__portal_pool_id')
}
